export default __webpack_public_path__ + "static/media/drag_icon.3be068ca.svg";